import { render, staticRenderFns } from "./EditQuestion.vue?vue&type=template&id=3a3673e0"
import script from "./EditQuestion.vue?vue&type=script&lang=js"
export * from "./EditQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports